/**
 * Utility functions for transforming API responses between different formats
 */

/**
 * Converts camelCase user response to snake_case format
 * If already in snake_case format, returns as is
 */
// eslint-disable-next-line import/prefer-default-export
export const convertUserResponseToSnakeCase = (data: any): IGetMeResponse => {
  // If already in snake_case format, return as is
  if (data.account_id !== undefined) {
    return data;
  }

  // Convert camelCase to snake_case
  return {
    account_id: data.accountId || data.account_id || '',
    name: data.name || '',
    family_name: data.familyName || data.family_name || '',
    email: data.email || '',
    picture: data.picture || '',
    created_at: data.createdAt || data.created_at || '',
    updated_at: data.updatedAt || data.updated_at || '',
    stripe_customer_id: data.stripeCustomerId || data.stripe_customer_id || '',
    stripe_subscription_id:
      data.stripeSubscriptionId || data.stripe_subscription_id || '',
    stripe_product_id: data.stripeProductId || data.stripe_product_id || '',
    role_id: data.roleId || data.role_id || 0,
    role_name: data.roleName || data.role_name || '',
    email_verified: data.emailVerified || data.email_verified || true,
    credits: data.credits || 0,
    subscription_status:
      data.subscriptionStatus || data.subscription_status || '',
    subscription_plan_name:
      data.subscriptionPlanName || data.subscription_plan_name || '',
    is_lifetime: data.isLifetime || data.is_lifetime || false,
    subscription_current_period_start:
      data.subscriptionCurrentPeriodStart ||
      data.subscription_current_period_start ||
      null,
    subscription_current_period_end:
      data.subscriptionCurrentPeriodEnd ||
      data.subscription_current_period_end ||
      null,
    is_beta_user: data.isBetaUser || data.is_beta_user || false,
    migration_code: data.migrationCode || data.migration_code || '',
    is_migration_completed:
      data.isMigrationCompleted || data.is_migration_completed || false,
  };
};
